/* ============================================================
   HEINE VERSANDHAUS – Theme-Skripte
   1. Groessenassistent  2. Warenkorb-Fortschritt  3. Farbkacheln
   ============================================================ */
(function () {
  'use strict';

  /* ---------------------------------------------------------
     1. GROESSENASSISTENT
     --------------------------------------------------------- */

  var SA = {
    root: null, data: null, step: 0, answers: {}, result: null, steps: []
  };

  // Konfektionsgroessen-Tabellen
  var TBL = {
    damen: [
      { de: 34, label: 'XS', bmi: 18.6 },
      { de: 36, label: 'S',  bmi: 20.6 },
      { de: 38, label: 'M',  bmi: 23.0 },
      { de: 40, label: 'L',  bmi: 25.8 },
      { de: 42, label: 'XL', bmi: 28.6 },
      { de: 44, label: 'XXL', bmi: 31.4 },
      { de: 46, label: '3XL', bmi: 34.5 },
      { de: 48, label: '4XL', bmi: 99 }
    ],
    herren: [
      { de: 44, label: 'XS', bmi: 19.4 },
      { de: 46, label: 'S',  bmi: 21.4 },
      { de: 48, label: 'M',  bmi: 23.8 },
      { de: 50, label: 'L',  bmi: 26.4 },
      { de: 52, label: 'XL', bmi: 29.0 },
      { de: 54, label: 'XXL', bmi: 32.0 },
      { de: 56, label: '3XL', bmi: 99 }
    ]
  };

  function clampIdx(i, arr) { return Math.max(0, Math.min(arr.length - 1, i)); }

  function baseIndex(gender, h, w) {
    var m = h / 100;
    var bmi = w / (m * m);
    var tbl = TBL[gender] || TBL.damen;
    for (var i = 0; i < tbl.length; i++) { if (bmi <= tbl[i].bmi) return i; }
    return tbl.length - 1;
  }

  function computeApparel(a, gender, cat) {
    var tbl = TBL[gender] || TBL.damen;
    var idx = baseIndex(gender, a.height, a.weight);
    var shift = 0;

    // Statur / Koerperbau
    if (a.build === 'schlank') shift -= 0.6;
    if (a.build === 'kraeftig') shift += 0.6;

    // Passform-Vorliebe
    if (a.fit === 'eng') shift -= 0.5;
    if (a.fit === 'locker') shift += 0.7;

    // Koerpergroesse: sehr gross braucht bei Oberteilen oft eine Nummer mehr
    if (a.height >= 180 && gender === 'damen') shift += 0.35;
    if (a.height >= 192 && gender === 'herren') shift += 0.35;
    if (a.height <= 158 && gender === 'damen') shift -= 0.3;

    // Kategorie-Korrektur
    if (cat === 'jacken') { shift += 0.45; if (a.layer === 'ja') shift += 0.55; }
    if (cat === 'strick') shift += 0.2;
    if (cat === 'kleider' && a.fit !== 'locker') shift += 0.15;
    if (cat === 'hosen') shift += 0.0;
    if (cat === 'blusen' || cat === 'hemden') shift += 0.1;

    var f = idx + shift;
    var main = clampIdx(Math.round(f), tbl);
    var alt = null;
    var frac = f - Math.floor(f);
    if (frac > 0.32 && frac < 0.68) {
      alt = clampIdx(main === Math.floor(f) ? main + 1 : main - 1, tbl);
    }
    return { main: tbl[main], alt: alt !== null && alt !== main ? tbl[alt] : null, tbl: tbl };
  }

  function computeShoe(a) {
    var s = parseInt(a.shoeSize, 10);
    if (isNaN(s)) return null;
    var add = 0;
    if (a.width === 'breit') add += 1;
    if (a.width === 'schmal') add -= 0;
    if (a.socks === 'ja') add += 0.5;
    var main = Math.round(s + add);
    var alt = (add >= 0.5 && main !== s) ? s : (main + 1);
    return { main: { label: String(main), de: main }, alt: { label: String(alt), de: alt }, isShoe: true };
  }

  /* --- Schrittdefinitionen --- */
  function buildSteps(cfg) {
    var g = cfg.gender === 'herren' ? 'herren' : 'damen';
    var cat = cfg.cat;
    var steps = [];

    if (cat === 'schuhe') {
      steps.push({
        id: 'shoeSize',
        q: 'Welche Schuhgröße tragen Sie normalerweise?',
        hint: 'Geben Sie die EU-Größe an, in der Sie zuletzt bequem gelaufen sind.',
        type: 'number', min: 33, max: 50, unit: 'EU-Größe', placeholder: g === 'herren' ? 'z. B. 43' : 'z. B. 38'
      });
      steps.push({
        id: 'width',
        q: 'Wie würden Sie Ihre Fußbreite beschreiben?',
        hint: 'Bei einem kräftigen Spann oder breitem Vorfuß empfehlen wir eine Nummer größer.',
        type: 'choice', cols: 3,
        opts: [
          { v: 'schmal', t: 'Schmal', s: 'Schuhe sind mir oft zu weit' },
          { v: 'normal', t: 'Normal', s: 'Standardweite passt' },
          { v: 'breit', t: 'Breit', s: 'Ich brauche oft mehr Platz' }
        ]
      });
      steps.push({
        id: 'socks',
        q: 'Tragen Sie dazu meist dickere Socken?',
        hint: 'Für Herbst- und Winterschuhe planen wir dann etwas mehr Raum ein.',
        type: 'choice', cols: 2,
        opts: [
          { v: 'nein', t: 'Dünne Socken', s: 'Normale Strümpfe' },
          { v: 'ja', t: 'Dicke Socken', s: 'Woll- oder Wintersocken' }
        ]
      });
      return steps;
    }

    steps.push({
      id: 'body', q: 'Ihre Körpergröße und Ihr Gewicht',
      hint: 'Beides brauchen wir, um Ihre Konfektionsgröße realistisch zu schätzen.',
      type: 'body'
    });
    steps.push({
      id: 'build',
      q: g === 'herren' ? 'Wie ist Ihre Statur?' : 'Wie würden Sie Ihre Figur beschreiben?',
      hint: 'Zwei Menschen mit gleichem Gewicht brauchen je nach Statur oft unterschiedliche Größen.',
      type: 'choice', cols: 3,
      opts: [
        { v: 'schlank', t: 'Zierlich', s: g === 'herren' ? 'Schmale Schultern' : 'Schmaler Körperbau' },
        { v: 'normal', t: 'Normal', s: 'Ausgewogen' },
        { v: 'kraeftig', t: 'Kräftig', s: g === 'herren' ? 'Breite Schultern' : 'Kurvige Figur' }
      ]
    });
    steps.push({
      id: 'fit', q: 'Wie soll das Teil sitzen?',
      hint: 'Wir passen die Empfehlung Ihrer Vorliebe an.',
      type: 'choice', cols: 3,
      opts: [
        { v: 'eng', t: 'Körpernah', s: 'Figurbetont' },
        { v: 'normal', t: 'Normal', s: 'Wie angegeben' },
        { v: 'locker', t: 'Locker', s: 'Bequem, mit Luft' }
      ]
    });
    if (cat === 'jacken') {
      steps.push({
        id: 'layer', q: 'Tragen Sie darunter meist einen Pullover?',
        hint: 'Für Mäntel und Jacken planen wir dann zusätzlichen Platz ein.',
        type: 'choice', cols: 2,
        opts: [
          { v: 'nein', t: 'Eher dünn', s: 'Shirt oder Bluse' },
          { v: 'ja', t: 'Dicker Pullover', s: 'Strick oder Rollkragen' }
        ]
      });
    }
    return steps;
  }

  /* --- Rendering --- */
  function h(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }

  function renderStep() {
    var body = SA.root.querySelector('[data-sa-body]');
    var st = SA.steps[SA.step];
    body.innerHTML = '';

    var wrap = h('div', 'h-sa__step on');
    wrap.appendChild(h('p', 'h-sa__q', st.q));
    if (st.hint) wrap.appendChild(h('p', 'h-sa__hint', st.hint));

    if (st.type === 'body') {
      var row = h('div', 'h-sa__row2');
      row.innerHTML =
        '<div class="h-sa__field"><label for="hSaH">Körpergröße (cm)</label>' +
        '<input class="h-sa__input" id="hSaH" type="number" inputmode="numeric" min="130" max="215" placeholder="z. B. 168" value="' + (SA.answers.height || '') + '"></div>' +
        '<div class="h-sa__field"><label for="hSaW">Gewicht (kg)</label>' +
        '<input class="h-sa__input" id="hSaW" type="number" inputmode="numeric" min="35" max="200" placeholder="z. B. 68" value="' + (SA.answers.weight || '') + '"></div>';
      wrap.appendChild(row);
    } else if (st.type === 'number') {
      var f = h('div', 'h-sa__field');
      f.innerHTML = '<label for="hSaN">' + st.unit + '</label>' +
        '<input class="h-sa__input" id="hSaN" type="number" inputmode="numeric" min="' + st.min + '" max="' + st.max + '" placeholder="' + st.placeholder + '" value="' + (SA.answers[st.id] || '') + '">';
      wrap.appendChild(f);
    } else {
      var g = h('div', 'h-sa__opts' + (st.cols === 3 ? ' h-sa__opts--3' : ''));
      st.opts.forEach(function (o) {
        var b = h('button', 'h-sa__opt' + (SA.answers[st.id] === o.v ? ' on' : ''),
          o.t + (o.s ? '<small>' + o.s + '</small>' : ''));
        b.type = 'button';
        b.addEventListener('click', function () {
          SA.answers[st.id] = o.v;
          g.querySelectorAll('.h-sa__opt').forEach(function (x) { x.classList.remove('on'); });
          b.classList.add('on');
          setTimeout(next, 190);
        });
        g.appendChild(b);
      });
      wrap.appendChild(g);
    }

    wrap.appendChild(h('p', 'h-sa__err', ''));
    body.appendChild(wrap);

    // Fortschritt
    var prog = SA.root.querySelector('[data-sa-prog]');
    prog.innerHTML = '';
    for (var i = 0; i < SA.steps.length + 1; i++) {
      var s = document.createElement('i');
      if (i <= SA.step) s.className = 'on';
      prog.appendChild(s);
    }

    SA.root.querySelector('[data-sa-foot]').style.display = 'flex';
    SA.root.querySelector('[data-sa-back]').style.display = SA.step === 0 ? 'none' : 'block';
    SA.root.querySelector('[data-sa-next]').textContent =
      SA.step === SA.steps.length - 1 ? 'Größe berechnen' : 'Weiter';
  }

  function readStep() {
    var st = SA.steps[SA.step];
    var err = SA.root.querySelector('.h-sa__err');
    function fail(m) { err.textContent = m; err.classList.add('on'); return false; }
    err.classList.remove('on');

    if (st.type === 'body') {
      var hv = parseInt((SA.root.querySelector('#hSaH') || {}).value, 10);
      var wv = parseInt((SA.root.querySelector('#hSaW') || {}).value, 10);
      if (isNaN(hv) || hv < 130 || hv > 215) return fail('Bitte geben Sie Ihre Körpergröße zwischen 130 und 215 cm an.');
      if (isNaN(wv) || wv < 35 || wv > 200) return fail('Bitte geben Sie Ihr Gewicht zwischen 35 und 200 kg an.');
      SA.answers.height = hv; SA.answers.weight = wv;
      return true;
    }
    if (st.type === 'number') {
      var nv = parseInt((SA.root.querySelector('#hSaN') || {}).value, 10);
      if (isNaN(nv) || nv < st.min || nv > st.max) return fail('Bitte geben Sie eine Größe zwischen ' + st.min + ' und ' + st.max + ' an.');
      SA.answers[st.id] = nv;
      return true;
    }
    if (!SA.answers[st.id]) return fail('Bitte wählen Sie eine Antwort aus.');
    return true;
  }

  function next() {
    if (!readStep()) return;
    if (SA.step < SA.steps.length - 1) { SA.step++; renderStep(); }
    else { showResult(); }
  }
  function back() { if (SA.step > 0) { SA.step--; renderStep(); } }

  /* --- Groessen im Shop finden --- */
  function normalize(s) {
    return String(s).toLowerCase().replace(/[\s._-]/g, '')
      .replace('grosse', '').replace('größe', '').replace('gr', '');
  }
  function matchOption(label, de) {
    var opts = SA.data.sizeValues || [];
    var target = normalize(label);
    var targetDe = String(de);
    var found = null;
    opts.forEach(function (o) {
      var n = normalize(o);
      if (n === target) found = found || o;
    });
    if (found) return found;
    opts.forEach(function (o) {
      if (String(o).replace(/\D/g, '') === targetDe) found = found || o;
    });
    if (found) return found;
    opts.forEach(function (o) {
      var n = normalize(o);
      if (n.indexOf(target) === 0 || target.indexOf(n) === 0) found = found || o;
    });
    return found;
  }

  function showResult() {
    var cfg = SA.data;
    var res = cfg.cat === 'schuhe'
      ? computeShoe(SA.answers)
      : computeApparel(SA.answers, cfg.gender, cfg.cat);
    SA.result = res;

    var body = SA.root.querySelector('[data-sa-body]');
    var prog = SA.root.querySelector('[data-sa-prog]');
    prog.querySelectorAll('i').forEach(function (i) { i.className = 'on'; });
    SA.root.querySelector('[data-sa-foot]').style.display = 'none';

    var isShoe = !!res.isShoe;
    var mainLabel = isShoe ? res.main.label : res.main.label;
    var mainDe = res.main.de;
    var shopValue = matchOption(mainLabel, mainDe);
    var altValue = res.alt ? matchOption(res.alt.label, res.alt.de) : null;

    var altTxt = '';
    if (res.alt) {
      altTxt = '<p class="h-sa__alt">Sie liegen zwischen zwei Größen. Wenn Sie es ' +
        (SA.answers.fit === 'locker' ? 'lieber bequemer' : 'etwas großzügiger') +
        ' mögen, passt Ihnen auch <b>' + res.alt.label + (isShoe ? '' : ' (Gr. ' + res.alt.de + ')') + '</b>.</p>';
    }

    var sizeTxt = isShoe
      ? 'EU ' + mainLabel
      : mainLabel;
    var subTxt = isShoe ? '' : '<p class="h-sa__alt">entspricht Konfektionsgröße <b>' + mainDe + '</b></p>';

    var html =
      '<div class="h-sa__res">' +
      '<p class="lead">Ihre empfohlene Größe</p>' +
      '<div class="h-sa__size">' + sizeTxt + '</div>' +
      subTxt + altTxt +
      '<div class="h-sa__note">Diese Empfehlung ist eine sorgfältige Schätzung auf Basis Ihrer Angaben und unserer Schnitte &ndash; keine Garantie. ' +
      'Sie sind unsicher? Schreiben Sie uns an <a href="mailto:info@heineversandhaus.com?subject=Pers%C3%B6nliche%20Gr%C3%B6%C3%9Fenberatung">info@heineversandhaus.com</a> ' +
      'und wir beraten Sie persönlich &ndash; meist innerhalb weniger Stunden. Und falls die Größe doch nicht passt: Sie haben 90 Tage Rückgaberecht.</div>' +
      '<div class="h-sa__addwrap">' +
      (shopValue
        ? '<button type="button" class="h-sa__add" data-sa-add data-value="' + String(shopValue).replace(/"/g, '&quot;') + '">Größe ' + shopValue + ' in den Warenkorb</button>'
        : '<button type="button" class="h-sa__add" disabled>Diese Größe ist derzeit nicht verfügbar</button>') +
      '<button type="button" class="h-sa__restart" data-sa-restart>Angaben ändern</button>' +
      '</div></div>';

    body.innerHTML = html;

    var add = body.querySelector('[data-sa-add]');
    if (add) {
      add.addEventListener('click', function () {
        selectSize(add.getAttribute('data-value'));
        add.disabled = true;
        add.textContent = 'Wird hinzugefügt …';
        setTimeout(function () {
          closeSA();
          var atc = document.querySelector('.product-section [data-add-to-cart], .product-single__form [data-add-to-cart], form[action*="/cart/add"] [type=submit]');
          if (atc) atc.click();
          add.disabled = false;
        }, 340);
      });
    }
    var re = body.querySelector('[data-sa-restart]');
    if (re) re.addEventListener('click', function () { SA.step = 0; renderStep(); });
  }

  function selectSize(value) {
    var wraps = document.querySelectorAll('.variant-input-wrap, .h-swatches');
    for (var i = 0; i < wraps.length; i++) {
      var inputs = wraps[i].querySelectorAll('input[type=radio]');
      for (var j = 0; j < inputs.length; j++) {
        if (inputs[j].value === value) {
          inputs[j].checked = true;
          inputs[j].dispatchEvent(new Event('change', { bubbles: true }));
          inputs[j].dispatchEvent(new Event('click', { bubbles: true }));
          return true;
        }
      }
    }
    var sel = document.querySelectorAll('select.single-option-selector, select[data-product-select]');
    for (var k = 0; k < sel.length; k++) {
      var o = sel[k].querySelector('option[value="' + value + '"]');
      if (o) { sel[k].value = value; sel[k].dispatchEvent(new Event('change', { bubbles: true })); return true; }
    }
    return false;
  }

  function openSA() {
    var el = document.getElementById('HeineSizeAssistant');
    if (!el) return;
    SA.root = el;
    try { SA.data = JSON.parse(el.getAttribute('data-config') || '{}'); } catch (e) { SA.data = {}; }
    SA.steps = buildSteps(SA.data);
    SA.step = 0;
    SA.answers = {};
    el.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    renderStep();
  }
  function closeSA() {
    var el = document.getElementById('HeineSizeAssistant');
    if (!el) return;
    el.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest && t.closest('[data-size-assistant-open]')) { e.preventDefault(); openSA(); return; }
    if (t.closest && t.closest('[data-sa-close]')) { e.preventDefault(); closeSA(); return; }
    if (t.id === 'HeineSizeAssistant') { closeSA(); return; }
    if (t.closest && t.closest('[data-sa-next]')) { e.preventDefault(); next(); return; }
    if (t.closest && t.closest('[data-sa-back]')) { e.preventDefault(); back(); return; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSA();
    if (e.key === 'Enter' && document.getElementById('HeineSizeAssistant') &&
        document.getElementById('HeineSizeAssistant').classList.contains('is-open')) {
      var st = SA.steps[SA.step];
      if (st && (st.type === 'body' || st.type === 'number')) { e.preventDefault(); next(); }
    }
  });

  /* ---------------------------------------------------------
     2. WARENKORB-FORTSCHRITT
     --------------------------------------------------------- */
  var TIERS = [
    { qty: 2, pct: 10 },
    { qty: 3, pct: 15 },
    { qty: 4, pct: 20 }
  ];

  function cartCount() {
    var el = document.querySelector('[data-cart-count]');
    if (el) {
      var n = parseInt((el.textContent || '').replace(/\D/g, ''), 10);
      if (!isNaN(n)) return n;
    }
    var items = document.querySelectorAll('.drawer--cart [data-line], .cart-drawer [data-line], .drawer--cart .cart__item, .cart-drawer .cart__item');
    var total = 0;
    items.forEach(function (it) {
      var q = it.querySelector('input[name="updates[]"], [data-quantity-input], .cart__item-qty input');
      total += q ? (parseInt(q.value, 10) || 0) : 1;
    });
    return total;
  }

  function renderBar() {
    var bars = document.querySelectorAll('[data-heine-cartbar]');
    if (!bars.length) return;
    var n = cartCount();
    var reached = null, nextTier = null;
    TIERS.forEach(function (t) {
      if (n >= t.qty) reached = t;
      else if (!nextTier) nextTier = t;
    });
    var max = TIERS[TIERS.length - 1].qty;
    var pct = Math.min(100, (n / max) * 100);

    var txt;
    if (n === 0) {
      txt = 'Ab <b>2 Artikeln</b> sparen Sie <b>10&nbsp;%</b> – ab 4 Artikeln sogar 20&nbsp;%.';
    } else if (nextTier) {
      var miss = nextTier.qty - n;
      txt = (reached ? '<span class="hit">' + reached.pct + '&nbsp;% gesichert.</span> ' : '') +
        'Nur noch <b>' + miss + (miss === 1 ? ' Artikel' : ' Artikel') + '</b> bis <b>' + nextTier.pct + '&nbsp;%</b> Rabatt.';
    } else {
      txt = '<span class="hit">Geschafft – Sie erhalten den maximalen Rabatt von 20&nbsp;%.</span>';
    }

    bars.forEach(function (bar) {
      var t = bar.querySelector('.h-cartbar__txt');
      var f = bar.querySelector('.h-cartbar__fill');
      if (t) t.innerHTML = txt;
      if (f) f.style.width = pct + '%';
      bar.querySelectorAll('.h-cartbar__mark').forEach(function (m) {
        var q = parseInt(m.getAttribute('data-qty'), 10);
        m.classList.toggle('on', n >= q);
      });
    });
  }

  /* ---------------------------------------------------------
     3. FARBKACHELN – Label synchron halten
     --------------------------------------------------------- */
  function syncSwatchLabel(scope) {
    (scope || document).querySelectorAll('.h-swatches').forEach(function (w) {
      var checked = w.querySelector('input:checked');
      var out = document.querySelector('[data-variant-color-label][data-option-index="' + w.getAttribute('data-option-index') + '"]');
      if (checked && out) out.textContent = checked.value;
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('.h-swatches input')) syncSwatchLabel();
  });

  /* ---------------------------------------------------------
     Init + Beobachtung
     --------------------------------------------------------- */
  function init() { renderBar(); syncSwatchLabel(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('cart:updated', renderBar);
  document.addEventListener('cart:build', renderBar);
  document.addEventListener('ajaxProduct:added', function () { setTimeout(renderBar, 260); });

  // Fallback: DOM-Beobachter fuer den Drawer
  var mo = new MutationObserver(function () { clearTimeout(window.__hCartT); window.__hCartT = setTimeout(renderBar, 130); });
  function observe() {
    var d = document.querySelector('.drawer--cart, .cart-drawer, #CartDrawer');
    if (d) mo.observe(d, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe);
  else observe();
})();
